// ============================================================
// データ定義
// ============================================================
const questions = {
  q1: {
    text: '今日はどんな気分？',
    a: { label: 'A：シャキっと「オンスタイル」',     next: 'q2a' },
    b: { label: 'B：ゆるっと「オフスタイル」',       next: 'q2b' }
  },
  q2a: {
    text: 'オンスタイルで意識したいのは？',
    a: { label: 'A：好印象を与える「きれいめ感」',   next: 'q3a' },
    b: { label: 'B：周りと差がつく「トレンド感」',   next: 'q3b' }
  },
  q2b: {
    text: 'オフの日、どう過ごす？',
    a: { label: 'A：話題のスポットへ「アクティブ」にお出かけ', next: 'q3b' },
    b: { label: 'B：家や近所で「ゆったり」マイペースに',       next: 'q3c' }
  },
  q3a: {
    text: '憧れの女性像は？',
    a: { label: 'A：親しみやすい「柔らかな女性」',   next: 'q4a' },
    b: { label: 'B：自立した「スマートな女性」',     next: 'q3b' }
  },
  q3b: {
    text: '小物を合わせるなら？',
    a: { label: 'A：パールや華奢なアクセで「上品に」',  next: 'q4a' },
    b: { label: 'B：サングラスで「こなれた印象に」',    next: 'q4b' }
  },
  q3c: {
    text: 'よく合わせるボトムスは？',
    a: { label: 'A：スカート派', next: 'q3b' },
    b: { label: 'B：パンツ派',   next: 'q4b' }
  },
  q4a: {
    text: '体型カバーで隠したいのは？',
    a: { label: 'A：お腹周りをふんわりカバーしたい', next: 'q5a' },
    b: { label: 'B：二の腕をスッキリ細く見せたい',   next: 'q5b' }
  },
  q4b: {
    text: 'お洋服選びの「決め手」はどっち？',
    a: { label: 'A：1枚で「サマになるデザイン」', next: 'q5c' },
    b: { label: 'B：シンプルで「着回しが効く」',  next: 'q5d' }
  },
  q5a: {
    text: '理想の仕上がりはどっち？',
    a: { label: 'A：凜とした「華やか上品スタイル」',   next: 'result01' },
    b: { label: 'B：肩の力が抜けた「抜け感スタイル」', next: 'result03' }
  },
  q5b: {
    text: '二の腕のカバー、どっちが好み？',
    a: { label: 'A：袖のボリュームで可愛く隠す',           next: 'result01' },
    b: { label: 'B：スッキリな縦ラインでさりげなく隠す',   next: 'result02' }
  },
  q5c: {
    text: '「涼しさ」で重視するのは？',
    a: { label: 'A：とにかく涼しく上品な着こなし', next: 'result02' },
    b: { label: 'B：抜け感でヘルシーな着こなし',   next: 'result04' }
  },
  q5d: {
    text: 'シンプルコーデのワンポイントは？',
    a: { label: 'A：後ろ姿に遊び心がある', next: 'result03' },
    b: { label: 'B：広めのネックライン',   next: 'result04' }
  }
};

const results = {
  result01: {
    nameEn:     'Frill Shirt',
    nameJa:     'フリルトップス',
    style:      '「華やかなオフィススタイル」',
    styleBg:    '#5082ff',
    illust:     'assets/images/answer/1/illust.webp',
    desc:       'ブラウス見える異素材フリルが、この夏を際立てつつ顔周りを華やかに。お仕事や行事でも「きちんと感」と涼しさを両立します。',
    point:      'フレアスカート合わせで女性らしさをプラスしつつ、小物を黒にまとめると、品よく華やかな「お仕事コーデ」に！',
    itemImg:    'assets/images/answer/1/item.webp',
    itemName:   '異素材フリル BIGT',
    itemPrice:  '¥4,400',
    link:       'https://www.dot-st.com/lepsim/disp/item/242843/?COLOR_CD=05'
  },
  result02: {
    nameEn:     'Sleeveless',
    nameJa:     'ノースリーブ',
    style:      '「知的なきれいめスタイル」',
    styleBg:    '#f7931e',
    illust:     'assets/images/answer/2/illust.webp',
    desc:       '肩を出しすぎない安心設計で、ノースリーブが苦手な方にもおすすめ。シリーズNo.1の涼しさと知的なIラインが魅力です。',
    point:      'ロングネックレスを添えて縦ラインを強調し、黒のイージーパンツでまとめれば、洗練された大人の誰もが誘われるスタイルに。',
    itemImg:    'assets/images/answer/2/item.webp',
    itemName:   'ノースリーブ',
    itemPrice:  '¥4,400',
    link:       'https://www.dot-st.com/lepsim/disp/item/242849/?COLOR_CD=35'
  },
  result03: {
    nameEn:     'Big T-Shirt',
    nameJa:     'ビッグTシャツ',
    style:      '「抜け感カジュアルスタイル」',
    styleBg:    '#ff70da',
    illust:     'assets/images/answer/3/illust.webp',
    desc:       'ロゴパッチが光る後ろ姿までお洒落な一枚。ゆったりシルエットがお腹周りを自然にカバーし、肩の力が抜けた抜け感を演出します。',
    point:      '裾からレースを覗かせたデニムスタイルにキャップを合わせれば、大人可愛い休日コーデのできあがり。',
    itemImg:    'assets/images/answer/3/item.webp',
    itemName:   'ビッグTシャツ',
    itemPrice:  '¥4,400',
    link:       'https://www.dot-st.com/lepsim/disp/item/242850/?COLOR_CD=05'
  },
  result04: {
    nameEn:     'Off Shoulder',
    nameJa:     'オフショルダー',
    style:      '「こなれモードスタイル」',
    styleBg:    '#9256ff',
    illust:     'assets/images/answer/4/illust.webp',
    desc:       'ヘルシーな肌見せが叶うネックラインで、都会的な抜け感を。持続冷感とトレンドが直結したデザインは、女子会の主役級アイテム。',
    point:      '柄入りのワイドパンツや大ぶりなアクセを合わせれば、モードかつ夏のリゾートにもぴったりなコーデの完成！',
    itemImg:    'assets/images/answer/4/item.webp',
    itemName:   'オフショルダー',
    itemPrice:  '¥4,400',
    link:       'https://www.dot-st.com/lepsim/disp/item/242876/?COLOR_CD=18'
  }
};

// ============================================================
// 状態
// ============================================================
let current = 'q1';
let history = [];

// ============================================================
// DOM参照
// ============================================================
const secStart    = document.getElementById('sec-start');
const secQuestion = document.getElementById('sec-question');
const secResult   = document.getElementById('sec-result');
const qText       = document.getElementById('q-text');
const qStep       = document.getElementById('q-step');
const btnA        = document.getElementById('btn-a');
const btnB        = document.getElementById('btn-b');
const btnBack     = document.getElementById('btn-back');

// ============================================================
// ユーティリティ
// ============================================================
function showSection(el) {
  [secStart, secQuestion, secResult].forEach(s => {
    s.classList.remove('is-active');
    s.querySelectorAll('.fadeInUp').forEach(el => el.classList.remove('active'));
  });
  el.classList.add('is-active');
  window.scrollTo(0, 0);
  setTimeout(() => {
    el.querySelectorAll('.fadeInUp').forEach(el => el.classList.add('active'));
  }, 50);
}

// ============================================================
// 質問表示
// ============================================================
const stepMap = {
  q1: 1,
  q2a: 2, q2b: 2,
  q3a: 3, q3b: 3, q3c: 3,
  q4a: 4, q4b: 4,
  q5a: 5, q5b: 5, q5c: 5, q5d: 5
};

function renderQuestion(qId) {
  const q = questions[qId];
  btnBack.classList.toggle('is-hidden', history.length === 0);
  showSection(secQuestion);
  setTimeout(() => {
    qStep.textContent = 'Q' + stepMap[qId] + ' / 5';
    qText.textContent = q.text;
    btnA.textContent  = q.a.label;
    btnB.textContent  = q.b.label;
  }, 50);
}

// ============================================================
// 回答処理
// ============================================================
function answer(choice) {
  const next = questions[current][choice].next;
  history.push(current);
  if (next.startsWith('result')) {
    renderResult(next);
  } else {
    current = next;
    renderQuestion(current);
  }
}

// ============================================================
// 結果表示
// ============================================================
function renderResult(resultId) {
  const r = results[resultId];
  document.getElementById('r-name-en').textContent          = r.nameEn;
  document.getElementById('r-name-ja').textContent          = r.nameJa;
  document.getElementById('r-style').textContent            = r.style;
  document.getElementById('r-style').style.backgroundColor  = r.styleBg;
  document.getElementById('r-desc').textContent       = r.desc;
  document.getElementById('r-point').textContent      = r.point;
  document.getElementById('r-point-name').textContent  = r.itemName;
  document.getElementById('r-point-price').textContent = r.itemPrice;
  document.getElementById('r-link').href              = r.link;

  const img = document.getElementById('r-img');
  img.src = r.illust;
  img.alt = r.nameJa;

  document.getElementById('r-point-img').src = r.itemImg;
  document.getElementById('r-point-img').alt = r.itemName;

  showSection(secResult);
}

// ============================================================
// リセット
// ============================================================
function reset() {
  current = 'q1';
  history = [];
  showSection(secStart);
}

// ============================================================
// イベント
// ============================================================
document.getElementById('btn-start').addEventListener('click', () => {
  current = 'q1';
  history = [];
  renderQuestion('q1');
});

btnA.addEventListener('click', () => answer('a'));
btnB.addEventListener('click', () => answer('b'));

btnBack.addEventListener('click', () => {
  if (history.length === 0) return;
  current = history.pop();
  renderQuestion(current);
});

document.getElementById('btn-retry').addEventListener('click', reset);

// 初期表示アニメーション
setTimeout(() => {
  secStart.querySelectorAll('.fadeInUp').forEach(el => el.classList.add('active'));
}, 50);
